var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkUplaodSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3865 13.1334C8.97988 13.2334 8.97988 15.2734 10.3865 15.3734H13.7265C14.1332 15.3734 14.5199 15.2267 14.8199 14.9534C15.8065 14.0934 15.2799 12.36 13.9799 12.2C13.5132 9.38668 9.43988 10.4534 10.4065 13.1334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3865 13.1334C8.97988 13.2334 8.97988 15.2734 10.3865 15.3734H13.7265C14.1332 15.3734 14.5199 15.2267 14.8199 14.9534C15.8065 14.0934 15.2799 12.36 13.9799 12.2C13.5132 9.38668 9.43988 10.4534 10.4065 13.1334"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 7.37992V10.2266C14.6668 10.4399 14.3268 10.5333 14.1802 10.3799C13.8668 10.0533 13.4735 9.80659 13.0202 9.66659C11.9735 9.33992 10.7668 9.65992 10.0068 10.4466C9.52683 10.9599 9.26683 11.5999 9.2535 12.2933C9.2535 12.4133 9.1935 12.5199 9.10016 12.5933C8.62016 12.9733 8.32683 13.5666 8.32683 14.2466V14.2533C8.32683 14.4666 8.1735 14.6599 7.96016 14.6599H4.8935C2.9335 14.6666 1.3335 13.0666 1.3335 11.0999V4.27992C1.3335 2.65325 2.6535 1.33325 4.28016 1.33325H5.82683C6.9135 1.33325 7.2535 1.68659 7.68683 2.26659L8.62016 3.50659C8.82683 3.77992 8.8535 3.81325 9.24016 3.81325H11.1002C12.6868 3.81325 14.0335 4.85325 14.4935 6.29325C14.5935 6.59325 14.6468 6.89992 14.6602 7.22659C14.6668 7.27325 14.6668 7.33325 14.6668 7.37992Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkUplaodSign);
export default __webpack_public_path__ + "static/media/linkUplaodSign.2f0033a0b277cd96783328ecda9b2b20.svg";
export { ForwardRef as ReactComponent };